// extracted by mini-css-extract-plugin
export default {"loadercontainer":"PageLoader_loadercontainer__tOUxy","loader":"PageLoader_loader__Y8vSr","animloader":"PageLoader_animloader__k4YeK"};